var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-main"},[_c('router-view',{key:_vm.key}),_c('contextmousemenucom',{ref:"contextmousemenucom",on:{"menuClickEventHandler":_vm.menuClickEventHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }